import { type JSX, type ReactNode } from 'react';
import { cx } from '@linaria/core';

import { useTranslation } from '@cx-modules/i18n-provider';

import {
  BookmakersHeading,
  EachWayTermsHeading,
  MobileOddsHeadingWrapper,
  OddsHeading,
  OddsHeadingWrapper,
  SingleHeading,
} from './style';

export const OddsHeadingMobile = ({ children }: { children: ReactNode }): JSX.Element => {
  const showEachWayTerms = false;
  const { t } = useTranslation('label');
  const oddsLabel = t('ODDS', { ns: 'label' });
  const eachWayLabel = t('EACH_WAY', { ns: 'label' });
  return (
    <OddsHeadingWrapper>
      <BookmakersHeading>{children}</BookmakersHeading>
      <MobileOddsHeadingWrapper className={cx(!showEachWayTerms && SingleHeading)}>
        {showEachWayTerms && <EachWayTermsHeading>{eachWayLabel}</EachWayTermsHeading>}
        <OddsHeading>{oddsLabel}</OddsHeading>
      </MobileOddsHeadingWrapper>
    </OddsHeadingWrapper>
  );
};
